import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Library} from './library.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LibraryService} from '../services/library.service';
import {DEFAULT_LIBRARIES_ITEMS_PAGE_NUMBER} from '../constants/library-constants';
import {DialogService} from '../services/dialog.service';
import {extractErrorMessage} from '../utils/error-utils';

export class LibrariesDataSource implements DataSource<Library> {

  private librariesSubject = new BehaviorSubject<Library[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private nextPageToken: string;
  public loading$ = this.loadingSubject.asObservable();
  public libraries: Library[] = [];
  public librariesCount: number;

  constructor(private libService: LibraryService, private dialogService: DialogService) {
  }

  connect(collectionViewer: CollectionViewer): Observable<Library[]> {
    return this.librariesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.librariesSubject.complete();
    this.loadingSubject.complete();
  }

  loadLibraries(filter = '', query = '', pageIndex = 0, pageSize = DEFAULT_LIBRARIES_ITEMS_PAGE_NUMBER): void {
    this.loadingSubject.next(true);
    this.libService.searchLibraries(filter, query, pageSize, this.nextPageToken).pipe(
      finalize(() => this.loadingSubject.next(false))
    ).subscribe({
      next: (resp) => {
        if (!resp.libraries) {
          resp.libraries = [];
        }
        this.librariesCount = resp.totalCount;
        this.librariesSubject.next(resp.libraries);
        this.nextPageToken = resp.nextPageToken;
        this.libraries.push(...resp.libraries);
      },
      error: (error) => {
        this.dialogService.error(extractErrorMessage(error));
      }
    });
  }

  public loadLibrariesPage(eventPageIndex: number,
                           libraryListFilter: string,
                           query = '',
                           pageIndex = 0,
                           pageSize = DEFAULT_LIBRARIES_ITEMS_PAGE_NUMBER): void {

    const start = eventPageIndex * pageSize;
    const end = (eventPageIndex + 1) * pageSize;

    if (start >= this.libraries.length) {
      this.loadLibraries(libraryListFilter, query, pageIndex, pageSize);
    } else {
      this.librariesSubject.next(this.libraries.slice(start, end));
    }
  }

  init(libraryListFilter: string, query: string, pageIndex: number, pageSize: number): void {
    this.nextPageToken = null;
    this.libraries = [];
    this.loadLibraries(libraryListFilter, query, pageIndex, pageSize);
  }
}
